import { Observable } from 'rxjs';

export abstract class FormatNumberService {
	abstract ready$: Observable<boolean>;
	abstract formatNumber$(number: number, format: string): Observable<string>;
	abstract formatNumber(number: number, format: string): string;
}
